import { Grid, Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { GenerationsChart } from "Reporting/Components/GenerationsChart";
import { JobStatusChart } from "Reporting/Components/JobStatusChart";
import { PartnerMetricsCharts } from "Reporting/Components/PartnerMetricsCharts";
import { ProjectStatusChart } from "Reporting/Components/ProjectStatusChart";
import { ReportingKpis } from "Reporting/Components/ReportingKpis";
import { RevenueChart } from "Reporting/Components/RevenueChart";
import { TopActorsChart } from "Reporting/Components/TopActorsChart";
import { VoiceModelUsageChart } from "Reporting/Components/VoiceModelUsageChart";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ReportingPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Reporting.Title)}>
      <Stack spacing={Spacing.M}>
        {/* Row 1: KPI cards */}
        <ReportingKpis />

        {/* Row 2: Revenue chart + Project status donut */}
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 8 }}>
            <RevenueChart />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <ProjectStatusChart />
          </Grid>
        </Grid>

        {/* Row 3: Top actors */}
        <TopActorsChart />

        {/* Row 4: Partner metrics */}
        <PartnerMetricsCharts />

        {/* Row 5: Generations, Voice model usage, Job status */}
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 5 }}>
            <GenerationsChart />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
            <VoiceModelUsageChart />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <JobStatusChart />
          </Grid>
        </Grid>
      </Stack>
    </AuthenticatedLayout>
  );
};
